import React from "react";
import {
  StepCard,
  StepTitle,
  StepSubtitle,
  FormGroup,
  SelectableCardsGrid,
  SelectableCard,
  NavigationButtonsRow,
  ActionButton,
} from "../registerStyles";

const PACIENTES_OPTIONS = [
  {
    id: "less_50",
    icon: "🌱",
    title: "Menos de 50",
    desc: "Atención selectiva o recién comenzando",
  },
  {
    id: "50_200",
    icon: "📈",
    title: "50 a 200 pacientes",
    desc: "Flujo regular y en crecimiento constante",
  },
  {
    id: "more_200",
    icon: "🚀",
    title: "Más de 200",
    desc: "Alto volumen diario de pacientes",
  },
];

export const StepDiagnosisPacientes = ({
  formData,
  setFormData,
  onNext,
  onBack,
}) => {
  const isSelected = Boolean(formData.volumenPacientes);

  return (
    <StepCard>
      <StepTitle>Volumen de pacientes al mes</StepTitle>
      <StepSubtitle>
        Conocer tu flujo de atención nos permite recomendarte las herramientas adecuadas.
      </StepSubtitle>

      <FormGroup>
        <SelectableCardsGrid columns={3}>
          {PACIENTES_OPTIONS.map((opt) => {
            const selected = formData.volumenPacientes === opt.id;
            return (
              <SelectableCard
                key={opt.id}
                selected={selected}
                onClick={() => {
                  setFormData({ ...formData, volumenPacientes: opt.id });
                  onNext("volumenPacientes", opt.id);
                }}
              >
                <div className="icon-wrapper">{opt.icon}</div>
                <h4 className="card-title">{opt.title}</h4>
                <p className="card-description">{opt.desc}</p>
              </SelectableCard>
            );
          })}
        </SelectableCardsGrid>
      </FormGroup>

      <NavigationButtonsRow>
        <ActionButton type="button" onClick={onBack}>
          ← Atrás
        </ActionButton>
      </NavigationButtonsRow>
    </StepCard>
  );
};
